import React from 'react';
import DfbHeadline from '../ui-kit/dfb_headline';
import CSpeaker from '../elements/c_speaker';
import Section from "./section"

const MSpeakerGrid = (props) => {
  const collection = props.data.person_tile;
  return (
    <Section
      baseClass="m-SpeakerGrid"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-SpeakerGrid-wrapper">
        <div className="m-SpeakerGrid-container">
          <div className="m-SpeakerGrid-header">
            <DfbHeadline headline={props.data.headline} headline_level="h3" add_class="m-SpeakerGrid-headline" />
          </div>
          <div className="m-SpeakerGrid-speakerCardsContainer">
            <div className="m-SpeakerGrid-speakerCards">
              {collection.map((item, index) => (
                <div className="m-SpeakerGrid-speakerCard" key={`${props.data.uid}-${index + 1}`}>
                  <CSpeaker id={`${props.data.uid}-${index + 1}`} {...item} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default MSpeakerGrid;
